import z from "zod";

const deviceLocationDataSchema = z.object({
    ip: z.string(),
    code: z.string(),
    chargeId: z.string(),
    deviceSerial: z.string(),
    location: z.object({
        new: z.object({ latitude: z.number(), longitude: z.number(), timestamp: z.number() }),
        old: z.object({ latitude: z.number(), longitude: z.number(), timestamp: z.number() }),
    }),
});

const deviceMemoryDataSchema = z.object({
    ip: z.string().optional(),
    code: z.string().optional(),
    chargeId: z.string().optional(),
    deviceSerial: z.string().optional(),
    memory: z.object({ new: z.string(), old: z.string() }),
});

const deviceDataSchema = z.object({
    ip: z.string(),
    code: z.string(),
    chargeId: z.string(),
    deviceSerial: z.string(),
});

const deviceUpdatedDataSchema = z.object({
    ip: z.string().optional(),
    code: z.string().optional(),
    chargeId: z.string().optional(),
    deviceSerial: z.string().optional(),
    emteriaVersion: z.object({ new: z.string(), old: z.string() }),
});

export { deviceDataSchema, deviceLocationDataSchema, deviceMemoryDataSchema, deviceUpdatedDataSchema };
